import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { useContext } from 'react';
import { UserContext } from '../../../context/UserContext';
import { isAdmin, isModerator } from '../../utils/roles';
import './AdminLayout.css';

const AdminLayout = () => {
    const { currentUser, signOut } = useContext(UserContext);

    return (
        <div className="admin-layout">
            <Navbar className="admin-header" expand="lg">
                <Container>
                    <Navbar.Brand as={Link} to="/admin/dashboard">
                        HRNB Admin
                    </Navbar.Brand>
                    <Navbar.Toggle />
                    <Navbar.Collapse className="justify-content-end">
                        <Nav>
                            <Nav.Item>
                                <span className="admin-user-name">
                                    {currentUser?.username || currentUser?.email}
                                </span>
                            </Nav.Item>
                            <Nav.Item>
                                <Link to="/cabinet" className="admin-nav-link">
                                    Кабинет
                                </Link>
                            </Nav.Item>
                            <Nav.Item>
                                <span 
                                    className="admin-logout-btn" 
                                    onClick={signOut}
                                >
                                    Выйти
                                </span>
                            </Nav.Item>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>

            <div className="admin-container">
                <aside className="admin-sidebar">
                    <Nav className="admin-nav">
                        {/* Общие разделы для всех авторизованных */}
                        <Nav.Link as={Link} to="/admin/dashboard">
                            📊 Дашборд
                        </Nav.Link>

                        {/* Разделы для администраторов */}
                        {isAdmin(currentUser) && (
                            <>
                                <Nav.Link as={Link} to="/admin/users">
                                    👥 Пользователи
                                </Nav.Link>
                                <Nav.Link as={Link} to="/admin/battles">
                                    ⚔️ Баттлы
                                </Nav.Link>
                                <Nav.Link as={Link} to="/admin/battles/participants">
                                    📋 Заявки участников
                                </Nav.Link>
                                <Nav.Link as={Link} to="/admin/files">
                                    📁 Файлы
                                </Nav.Link>
                                <Nav.Link as={Link} to="/admin/rules">
                                    📋 Правила
                                </Nav.Link>
                                <Nav.Link as={Link} to="/admin/platform-rules">
                                    📜 Правила платформы
                                </Nav.Link>
                                <Nav.Link as={Link} to="/admin/chats">
                                    💬 Чаты
                                </Nav.Link>
                                <Nav.Link as={Link} to="/admin/stickers">
                                    🎨 Стикеры
                                </Nav.Link>
                                <Nav.Link as={Link} to="/admin/forum/categories">
                                    📂 Категории
                                </Nav.Link>
                            </>
                        )}

                        {/* Разделы для модераторов и администраторов */}
                        {isModerator(currentUser) && (
                            <>
                                <Nav.Link as={Link} to="/admin/moderation">
                                    🃏 Модерация
                                </Nav.Link>
                                <Nav.Link as={Link} to="/admin/forum/posts">
                                    📝 Посты
                                </Nav.Link>
                                <Nav.Link as={Link} to="/admin/forum/comments">
                                    💬 Комментарии
                                </Nav.Link>
                                <Nav.Link as={Link} to="/admin/forum/tags">
                                    🏷️ Теги
                                </Nav.Link>
                            </>
                        )}
                    </Nav>
                </aside>

                <main className="admin-content">
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default AdminLayout;
